import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

export default function HotRecommend() {
  const hotComics = comics.slice(0, 6);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950"
            style={{ fontFamily: "var(--font-heading)" }}>
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            本周最受欢迎的韩国漫画，不容错过
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 韩漫网高清韩国漫画`}
                  title={`${comic.title} - 韩漫网免费韩漫在线阅读`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {index === 0 && (
                  <div className="absolute top-2 left-2 bg-primary-500 text-white text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap">
                    热门
                  </div>
                )}
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 text-center truncate whitespace-nowrap">
                {comic.title}
              </h3>
              <div className="flex items-center justify-center gap-1.5 mt-1">
                <span className="text-accent-500 font-bold text-xs">{comic.rating}</span>
                <span className="text-foreground-400 text-xs">{comic.views}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}